// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1zVTU","clinicsSelect":"TableHeading_clinicsSelect__1CK3x"};